import { Component } from 'solid-js'
import { VoiceSettingForm } from '../../../../../common/types/texttospeech-schema'
import RangeInput from '../../../../shared/RangeInput'
import { i18nStore } from '/web/store'

export const WebSpeechSynthesisSettings: Component<{
  settings: VoiceSettingForm<'webspeechsynthesis'>
  onChange: (value: VoiceSettingForm<'webspeechsynthesis'>) => void
}> = (props) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const update = (diff: Partial<VoiceSettingForm<'webspeechsynthesis'>>) => {
    props.onChange({ ...props.settings, ...diff })
  }

  return (
    <>
      <RangeInput
        fieldName="webSpeechSynthesisStability"
        label={i18n.t.voice_pitch}
        helperText={i18n.t.voice_pitchHelper}
        value={props.settings.pitch ?? 1}
        min={0}
        max={2}
        step={0.01}
        onChange={(value) => update({ pitch: value })}
      />
      <RangeInput
        fieldName="webSpeechSynthesisSimilarityBoost"
        label={i18n.t.voice_rate}
        helperText={i18n.t.voice_rateHelper}
        value={props.settings.rate ?? 1}
        min={0.1}
        max={10}
        step={0.01}
        onChange={(value) => update({ rate: value })}
      />
    </>
  )
}
